import Vue from "vue";
import { findInFormAnswer } from "./find_in_form_answer.js";

export class FreeFormInput {
  constructor() {
    this.type = "free";
    this.data = {
      required: false,
      question: "",
    };
  }
}

export let FreeFormInputComponent = Vue.extend({
  props: ["input"],
  template: "#free-form-input-template",
  data: function () {
    return {
      trainee_answer: "",
    };
  },
  created: function () {
    const answer = findInFormAnswer(this.input);
    if (answer !== undefined) {
      this.trainee_answer = answer;
    }
  },
  watch: {
    trainee_answer: function () {
      this.$root.onTraineeAnswer(this);
    },
  },
});
